import { render, staticRenderFns } from "./PublicService.vue?vue&type=template&id=6d614fe1&scoped=true"
import script from "./PublicService.vue?vue&type=script&lang=js"
export * from "./PublicService.vue?vue&type=script&lang=js"
import style0 from "./PublicService.vue?vue&type=style&index=0&id=6d614fe1&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d614fe1",
  null
  
)

export default component.exports